import { render, staticRenderFns } from "./PurchaseGalleryProvider.vue?vue&type=template&id=e81b3b14&scoped=true&"
import script from "./PurchaseGalleryProvider.vue?vue&type=script&lang=ts&"
export * from "./PurchaseGalleryProvider.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseGalleryProvider.vue?vue&type=style&index=0&id=e81b3b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81b3b14",
  null
  
)

export default component.exports